import axios from 'axios';
import { API_URL } from '../config';

export interface PublicSettings {
  ordersEnabled: boolean;
}

export const getPublicSettings = async (): Promise<PublicSettings> => {
  const response = await axios.get<PublicSettings>(`${API_URL}/settings`);
  return response.data;
};

export const updateSettings = async (settings: { ordersEnabled: boolean }): Promise<PublicSettings> => {
  const token = localStorage.getItem('token');
  const response = await axios.put<PublicSettings>(`${API_URL}/settings`, settings, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};
